import script from "./RegisterSponsorAccountForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterSponsorAccountForm.vue?vue&type=script&setup=true&lang=js"

import "./RegisterSponsorAccountForm.vue?vue&type=style&index=0&id=b80ed33e&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b80ed33e"]])

export default __exports__